import { css } from 'styled-components'

/**
 * Overlay scrollbar that fades in on hover.
 * Applies a thin, semi-transparent scrollbar that only appears when
 * the user hovers over the scrollable container.
 *
 * Usage:
 *   const ScrollableUI = styled.div`
 *     overflow: hidden auto;
 *     ${overlayScrollbar}
 *   `
 */
export const overlayScrollbar = css`
  overflow: hidden auto;

  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.05) transparent;

  &:hover {
    scrollbar-color: rgba(0, 0, 0, 0.5) transparent;
  }

  &::-webkit-scrollbar {
    width: 16px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0);
    background-clip: padding-box;
    border: 2px solid transparent;
    border-radius: 7px;
    transition: background-color 0.2s ease;
  }

  &:hover::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.5);
  }
`
